const directions = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  CENTER: 'center',
};

// we export it twice because in some places we use the default export,
// while in others the named export has advantages.
export const TOP = directions.TOP;
export const RIGHT = directions.RIGHT;
export const BOTTOM = directions.BOTTOM;
export const LEFT = directions.LEFT;
export const CENTER = directions.CENTER;

export default directions;

